/**
 * form-embed D8 — the website's form piece names each question's pieces as published parts (`question`,
 * `label`, `hint`, `choice` with its `selected` state), so a site can style them. Off everywhere else: the
 * Mini App's forms draw exactly as before.
 */
import { createContext, useContext } from 'react';

const FieldPartsContext = createContext(false);

/** Set by FormRenderer's `markParts`. */
export const FieldPartsProvider = FieldPartsContext.Provider;

/** A part's attributes while parts are marked; nothing otherwise. */
export function useFieldPart(): (name: 'question' | 'label' | 'hint' | 'choice', selected?: boolean) => Record<string, string> {
  const marked = useContext(FieldPartsContext);
  return (name, selected) => (marked ? { 'data-part': name, ...(selected ? { 'data-state': 'selected' } : {}) } : {});
}
